import { useQuery } from '@tanstack/react-query';
import type { PageResult, ProjectSummary } from '@blesk/contracts';
import { apiGet } from './api';

/**
 * Список объектов для фильтров и форм разделов (§13).
 *
 * Сервер вернёт только разрешённые роли объекты (§3), поэтому отдельной
 * фильтрации по `allowedProjects` в интерфейсе нет: она была бы вторым
 * местом принятия того же решения.
 *
 * Граница §20 — 100 объектов, поэтому список грузится одной страницей
 * и переиспользуется всеми разделами через общий ключ кэша.
 */
export function useProjectOptions() {
  return useQuery({
    queryKey: ['projects', 'options'],
    queryFn: () =>
      apiGet<PageResult<ProjectSummary>>('/api/projects', { status: 'ACTIVE', perPage: 200 }),
    select: (page) => page.items,
  });
}

/** Часовой пояс объекта по идентификатору; неизвестный — зона по умолчанию (§19). */
export function timezoneOf(
  projects: ProjectSummary[] | undefined,
  projectId: string | null,
  fallback: string,
): string {
  if (!projectId) return fallback;
  return projects?.find((project) => project.id === projectId)?.timezone ?? fallback;
}
